import { useEffect } from 'react'

import { dispatchEvent } from '@/utils/analytics-events'
import { PageViewedProps } from '@/utils/analytics-events/types/generalEvents'

export type PageEventProps = Omit<PageViewedProps, 'pageReferrer'>

export const useDispatchPageEvent = (props: PageEventProps) => {
  useEffect(() => {
    const pageReferrer = document !== undefined ? document.referrer : ''
    dispatchEvent({ ...props, pageReferrer })
    // We want to dispatch the event only once, when the component is mounted
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
